export const colors = {
    black: "#000000",
    black_with_opacity_85: "rgba(25, 25, 25, 0.85)",
    blue_dark: "#071237",
    blue_light: "#1557a1",
    gray_dark: "#262626",
    gray_semi_dark: "#464646",
    gray_light: "#e0e0e0",
    gray_medium: "#818181",
    gray_very_light: "rgb(246, 246, 246)",
    gray_very_medium: "#a2a2a2",
    primary: "#4FC1FF",
    quaternary: "#071237",
    red: "#ba1313",
    red_very_light: "#ffe9d8",
    red_with_opacity_50: "rgba(255, 0, 0, 0.50)",
    secondary: "#50B9FE",
    shieldActive: "#10a0ff",
    tertiary: "#b8ddf2",
    transparent: "transparent",
    white: "#ffffff",
    white_with_opacity_50: "rgba(255, 255, 255, 0.5)",
    white_with_opacity_80: "rgba(255, 255, 255, 0.8)",
    white_with_opacity_high: "rgba(255, 255, 255, 0.95)",
};

export default colors;
